module.exports = __webpack_public_path__ + "static/media/NumTestingScoreIcon.cdd7ea6c.svg";